import React from 'react';
import { FeedbackToolProvider } from './FeedbackToolProvider';
import FeedbackTool from './FeedbackTool';

function FeedbackToolWrapper({
  initialQueryParams = {},
  context = 'markingCriteria',
  ...props
}) {
  return (
    <FeedbackToolProvider 
      initialQueryParams={initialQueryParams}
      context={context}
    >
      <FeedbackTool
        {...props}
        setSelectedCriteria={props.setSelectedCriteria}
      />
    </FeedbackToolProvider>
  );
}

export default FeedbackToolWrapper; 